export default "__VITE_ASSET__Bq_iNmAK__"